<template>
  <section>
    <div id="patientInfoHeader">
      <h1 id="patientName">{{ activePatient ? activePatient.name : "Select A Patient" }}</h1>
      <div class="buttons">
        <button v-if="['English US', 'Testing'].indexOf(region) > -1" @click="showInfo('sirsSepsisText')">{{ $store.getters['getUIText']('sirssepsis') }} <img src="../assets/images/questionmark.png"
                                                                     alt="Question Mark"></button>
        <button v-if="['English US', 'Testing'].indexOf(region) > -1" @click="showInfo('severeShockText')">Severe + Shock <img src="../assets/images/questionmark.png" alt="Question Mark"></button>
        <button @click="showInfo('newsScoreText')">{{ $store.getters['getUIText']('newsscore') }} <img src="../assets/images/questionmark.png" alt="Question Mark"></button>
        <button @click="showInfo('sofaScoreText')">{{ $store.getters['getUIText']('sofascore') }} <img src="../assets/images/questionmark.png" alt="Question Mark"></button>
        <!--      {{activePatient ? Object.keys(activePatient.computed_vitals) : ""}}-->
      </div>
    </div>
    <ul id="vitals">
      <li>{{ $store.getters['getUIText']('temp') }}: {{
          activePatient ? activePatient.computed_vitals.Temp : "-"
        }}&deg;
      </li>
      <li>{{ $store.getters['getUIText']('bp') }}: {{
          activePatient ? activePatient.computed_vitals.SBP : "-"
        }}/{{ activePatient ? activePatient.computed_vitals.DBP : "-" }}
      </li>
      <li>{{ $store.getters['getUIText']('hr') }}: {{ activePatient ? activePatient.computed_vitals.HR : "-" }}</li>
      <li>{{ $store.getters['getUIText']('rr') }}: {{ activePatient ? activePatient.computed_vitals.RR : "-" }}</li>
      <li>{{ $store.getters['getUIText']('spo2') }}: {{ activePatient ? activePatient.computed_vitals.SpO2 : "-" }}</li>
      <li>{{ $store.getters['getUIText']('uo') }}: {{
          activePatient ? activePatient.computed_vitals["Urine Out"] : "-"
        }}
      </li>
      <li>{{ $store.getters['getUIText']('news') }}: {{ activePatient ? activePatient.computed_vitals.news : "-" }}</li>
      <li>{{ $store.getters['getUIText']('sofa') }}: {{ activePatient ? activePatient.computed_vitals.sofa : '-' }}</li>
    </ul>
    <div id="tabs">
      <button class="tab" :class="{'active': tabShown === 'chart'}" @click="tabShown = 'chart'">
        {{ $store.getters['getUIText']('chart') }}
      </button>
      <button class="tab" :class="{'active': tabShown === 'hnp'}" @click="tabShown = 'hnp'">
        {{ $store.getters['getUIText']('hp') }}
      </button>
    </div>
    <div class="tab-window">
      <div class="chart tab-content" v-if="tabShown === 'chart'">
        <h2>{{ $store.getters['getUIText']('physicalexam') }}</h2>
        <div id="physicalExam" class="chart-box">
          <div v-if="activePatient">{{ activePatient.physicalExam }}</div>
        </div>
        <h2>{{ $store.getters['getUIText']('labsdiagnostics') }}</h2>
        <div id="labsDiagnostics" class="chart-box">
          <template v-if="activePatient">
            <div v-if="activePatient.initialized_labs.length === 0">
              {{ $store.getters['getUIText']('nolabshavebeenorder') }}
            </div>
            <template v-else>
              <ul class="labs">
                <li v-for="(lab, index) in activePatient.finishedLabs" :key="index" class="lab">
                  <h3>{{ lab.name }}</h3>
                  <ul class="lab-group">
                    <li v-for="(result, subindex) in lab.results" :key="subindex">{{ result.name }}: {{ result.text }}
                    </li>
                  </ul>
                </li>
              </ul>
              <h3 v-if="activePatient.incompleteLabs.length">{{ $store.getters['getUIText']('awaitingresults') }}</h3>
              <ul class="pending-labs">
                <li v-for="(lab, index) in activePatient.incompleteLabs" :key="index" class="pending-lab">
                  {{ lab.name }}: {{ $store.getters['getUIText']('resultsin') }} {{ lab.displayTime }}
                </li>
              </ul>
            </template>
          </template>
        </div>
        <h2>{{ $store.getters['getUIText']('treatments') }}</h2>
        <div id="treatments" class="chart-box">
          <template v-if="activePatient">
            <div v-if="activePatient.initialized_treatments.length === 0">
              {{ $store.getters['getUIText']('notreatmentshavebee') }}
            </div>
            <template v-else>
              <ul>
                <li v-for="(treatment, index) in activePatient.incompleteTreatments" :key="index">{{ treatment.name }}:
                  {{ treatment.displayTime }}
                </li>
              </ul>
            </template>
          </template>
        </div>
      </div>
      <div class="h-and-p tab-content" v-if="tabShown==='hnp'">
        <div v-if="activePatient" id="patientHnp">
          <p><strong>{{ $store.getters['getUIText']('gender') }}</strong>: {{ activePatient.gender }}</p>
          <p><strong>{{ $store.getters['getUIText']('age') }}</strong>: {{ activePatient.history.Age }}</p>
          <h3>{{ $store.getters['getUIText']('chiefcomplaint') }}</h3>
          <p>{{ activePatient.history["Chief Complaint"] }}</p>
          <h3>{{ $store.getters['getUIText']('historyofpresentill') }}</h3>
          <p>{{ activePatient.history["History of Present Illness"] }}</p>
          <h3>{{ $store.getters['getUIText']('pastmedicalhistory') }}</h3>
          <p>{{ activePatient.history["Past Medical Illness"] }}</p>
        </div>
        <div v-else>{{ $store.getters['getUIText']('nopatientselected') }}.</div>
      </div>
    </div>
  </section>
</template>

<script>
import GameManager from "@/assets/js/GameManager";

export default {
  name: "patient-info",
  data() {
    return {
      tabShown: "chart",
      region: process.env.VUE_APP_REGION
    }
  },
  computed: {
    tip() {
      return GameManager.tip;
    },
    activePatient() {
      return GameManager.patients[GameManager.selectedSlot];
    }
  },
  methods: {
    showInfo(id){
      GameManager.showInfo(id)
    },
    hideInfo(){
      GameManager.hideInfo()
    }
  }
}
</script>

<style scoped lang="less">
@import (reference) "../assets/less/colors";

@media screen and (max-width: 750px) {
  #patientName{
    font-size: 1.5rem;
    text-align: center;
  }
  .buttons{
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    button{
      max-width: 40%;
      margin: 0 0 4px;
    }
  }
  #vitals{
    font-size: 0.75rem;
    li{
      padding: 0.75rem;
    }
  }
  .tab-window{
    padding: 1rem;
  }
  .tab-content {
    height: auto;
  }
  #patientInfoHeader{
    display: block;
    font-size: 0.2rem;
  }
}

@media screen and (min-width: 751px) {
  #patientName{
    font-size: 2rem;
  }
  #vitals{
    font-size: 1rem;
    li{
      padding: 1rem;
    }
  }
  .tab-window{
    padding: 1.5em;
  }
  .tab-content {
    height: 100%;
  }
  #patientInfoHeader{
    display: flex;
    justify-content: space-between;
  }
}

section {
  position: relative;
  //width: calc(65vw - 2rem);
  padding: 1.25vh 1.25vw;
  display: flex;
  //flex-wrap: wrap;
  flex-direction: column;
  width: 100%;
  box-sizing: border-box;
}

.buttons {
  //position: absolute;
  //top: 1rem;
  //right: 1rem;

  button {
    padding: 0.5rem;
    border: 0;
    background-image: linear-gradient(to bottom, @lightgray, lighten(@lightgray, 20%));
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin-left: 0.5rem;
    cursor: pointer;
  }

  img {
    margin-left: 0.25rem;
  }
}

#patientName {
  color: @red;
  margin: 0;
}

#vitals {
  list-style: none;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  border-top: 1px solid @darkgray;
  border-left: 1px solid @darkgray;
  li {
    flex: 1;
    padding: 0.9em;
    display: flex;
    align-items: center;
    border-right: 1px solid @darkgray;
    border-bottom: 1px solid @darkgray;
    white-space: nowrap;
  }
}

#tabs {
  .tab {
    font-size: 1rem;
    font-weight: bold;
    display: inline-block;
    padding: .3rem 1.5rem;
    box-sizing: border-box;
    border: 1px solid @darkgray;
    border-bottom: 0;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    margin-left: 0.3rem;
    background: @white;
    position: relative;
    top: 0;

    &.active {
      top: 1px;
      height: 30px;
    }
  }
}

.tab-window {
  border-radius: 0.35rem;
  border: 1px solid @darkgray;
  flex: 1;
  overflow-y: auto;
  max-width: calc(100% - 4px);
  box-sizing: border-box;
}

.tab-content {
  display: flex;
  flex-direction: column;
  //height: 100%;
  //overflow-y: scroll;
}

h2 {
  font-size: 1.1rem;
  padding: 0 0 0.5rem;
  margin: 0;
}

.chart-box {
  border: 1px solid @darkgray;
  border-radius: 0.3rem;
  flex: 1;
  overflow: auto;
  padding: 1rem;
  margin: 0 0 0.75rem;
  box-sizing: border-box;
}

#patientHnp {
  max-width: 40em;
  line-height: 1.3;

  h3 {
    margin: 1.5em 0 0;
  }
}

.labs {
  list-style: none;
  padding: 0;
  margin: 0;

  h3 {
    margin: 0;
  }

  .lab {
    margin: 0 0 1em;
  }

  .lab-group {
    padding: 0;
    margin: 0 1em;
    list-style: disc;

    li {
      margin: 0.25em 0;
    }
  }
}

.pending-labs {
  padding: 0;

  .pending-lab {
    margin: 0.25em 1em;
  }
}
</style>
